import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useResetPassword } from "@/hooks/useAuth";
import { PrimaryButton } from "@/shared/components/ui/Button/PrimaryButton";
import { showError, showSuccess } from "@/shared/utils/toast";
import CommonInput from "@/shared/components/ui/Input/CommonInput";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const resetMutation = useResetPassword();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleReset = async () => {
    if (password.length < 8) {
      showError("Password must be at least 8 characters long.");
      return;
    }
    if (password !== confirmPassword) {
      showError("Passwords do not match.");
      return;
    }

    try {
      const result = await resetMutation.mutateAsync({
        token: searchParams.get("token"),
        password,
      });
      localStorage.clear();
      sessionStorage.clear();
      showSuccess(result.message);
      navigate("/signup", { replace: true });
    } catch (error) {
      showError(error.message);
    }
  };

  return (
    <div className="flex items-center justify-center h-[100dvh] w-full">
      <div className="w-full max-w-md bg-white p-8">
        <h1 className="text-xl font-semibold text-gray-900 mb-2">Set a new password</h1>
        <p className="text-sm text-gray-500 mb-6">
          Enter a new password for your SalesWorx account.
        </p>
        <div className="flex flex-col gap-4">
          <CommonInput
            type="password"
            placeholder="New password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            variant="underline"
            wrapperClassName="w-full flex"
          />
          <CommonInput
            type="password"
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
            variant="underline"
            wrapperClassName="w-full flex"
          />
          <PrimaryButton
            onClick={handleReset}
            disabled={resetMutation.isPending}
            isLoading={resetMutation.isPending}
            startContent={false}
            className="max-w-md rounded-full px-3 py-5 text-sm font-normal"
          >
            Reset Password
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
